export const GET_WEIGHTS = "GET_WEIGHTS";
export const GET_WEIGHT = "GET_WEIGHT";
export const ADD_WEIGHT = "ADD_WEIGHT";
export const DELETE_WEIGHT = "DELETE_WEIGHT";
export const UPDATE_WEIGHT = "UPDATE_WEIGHT";
